import React from 'react';
import styled from 'styled-components';
import {
  CopyLinkIcon,
  FbBlackIcon,
  LinkedInBlackIcon,
  TwitterBlackIcon,
} from '../../../Common/SvgIcon/CommonSvgIcons';
import { useDispatch } from 'react-redux';
import { setMessage } from '../../../store/redux/slices/alertMessageSlice';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '2560px',
};
export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};

const Container = styled.div`
  padding-left: 120px;
  padding-right: 120px;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  @media only screen and ${device.tablet} {
    padding: 15px 24px;
  }
`;
const DividerLine = styled.div`
  border-bottom: 1px solid #000000;
`;

const IconContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const IconButton = styled.button`
  width: 33px;
  height: 29px;
  border: none;
  background: none;
  &:hover {
    cursor: pointer;
  }
`;
const BlogFooter = () => {
  const url = encodeURIComponent(window.location.href);
  const dispatch = useDispatch();

  return (
    <Container>
      {window?.innerWidth > 768 && <DividerLine />}
      <IconContainer>
        <IconButton
          onClick={() =>
            window.open(
              `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                url
              )}`,
              '_blank'
            )
          }
        >
          {FbBlackIcon}
        </IconButton>
        <IconButton
          style={{
            marginLeft: '-15px',
          }}
          onClick={() => {
            window.open(
              `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
              '_blank'
            );
          }}
        >
          {TwitterBlackIcon}
        </IconButton>
        <IconButton
          onClick={() => {
            window.open(
              `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                window.location.href
              )}`,
              '_blank'
            );
          }}
        >
          {LinkedInBlackIcon}
        </IconButton>
        <IconButton
          onClick={() => {
            navigator.clipboard.writeText(window.location.href);
            dispatch(
              setMessage({
                message: 'Link copied successfully!!',
                type: 'Success',
              })
            );
          }}
        >
          {CopyLinkIcon}
        </IconButton>
      </IconContainer>
      <DividerLine />
    </Container>
  );
};

export default BlogFooter;
